import { ICategoryItem } from '~/lib/data-contract';
import { AspectRatio } from '~/shared/components/AspectRatio/AspectRatio';
import { ImageMedia } from '~/shared/components/ImageMedia/ImageMedia';
import Link from '~/shared/components/Link/Link';
import { lgCondition, mdCondition, xsCondition } from '~/theme/lib/breakpoints';

import styles from './m21ListItem.module.css';

const imageSizes = [`${lgCondition} 16.667vw`, `${mdCondition} 25vw`, `${xsCondition} 50vw`].join(', ');

export type M21ListItemProps = ICategoryItem;
export const M21ListItem = ({ image, link: { url, text, ...linkProps } }: M21ListItemProps) =>
	image ? (
		<Link
			className={styles.root}
			href={url}
			isCustomStyle
			{...linkProps}
		>
			<AspectRatio ratio={1}>
				<ImageMedia
					sizes={imageSizes}
					image={image}
					fill
					objectFit="cover"
				/>
			</AspectRatio>
			<span className={styles.label}>{text}</span>
		</Link>
	) : null;
